import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 text-center px-4 py-12">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-2xl">
        <div className="mb-8">
          <h1 className="text-9xl md:text-[12rem] font-black text-teal-500/20 select-none">
            404
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-teal-50 rounded-full">
            <i className="ri-error-warning-line text-4xl text-teal-600"></i>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Página no encontrada
          </h2>
          
          <p className="text-base md:text-lg text-gray-600 mb-2">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
          
          <p className="text-sm text-gray-500 font-mono mb-8 break-all">
            {location.pathname}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
            <button
              onClick={handleGoHome}
              className="w-full sm:w-auto px-8 py-3 bg-teal-600 hover:bg-teal-700 text-white font-semibold rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line text-lg"></i>
              Volver al inicio
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-sm text-gray-500">
              Serás redirigido automáticamente en{" "}
              <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-100 text-teal-700 font-bold rounded-full">
                {countdown}
              </span>{" "}
              segundos
            </p>
          </div>
        </div>

        <div className="mt-8">
          <p className="text-sm text-gray-500">
            ¿Necesitas ayuda?{" "}
            <a 
              href="/soporte" 
              className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer"
            >
              Contacta a soporte
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}